import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './period-list.hbs'
import ExtendForm from './extend-form'
import appDisplay from 'scoreboard/components/app-display'
import calendars from 'scoreboard/components/calendars'
import PeriodForm from './period-form'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import conductor from 'scoreboard/components/conductor'
import CalendarForm from './calendar-form'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import ErrorView from 'scoreboard/components/error-view'
import DependenciesPreventActionView from 'scoreboard/components/edit/dependencies-prevent-action-view'
const createjQueryErrorHandler = DependenciesPreventActionView.createjQueryErrorHandler
import CalendarHistoryInfo from './calendar-history-info'
import permissions from 'scoreboard/components/permissions'
import config from 'scoreboard/components/config'
import StrongConfirmPrompt from 'scoreboard/components/strong-confirm-prompt'
import i18n from 'scoreboard/components/i18n'

var PeriodList = Backbone.View.extend({

	// this.calendar is a plain javascript object representing the calendar

	className: 'panel calendar-overview right-panel',

	events: {
		'click .extend': 'extend',
		'click .add-period': 'addPeriod',
		'click .edit-period': 'editPeriod',
		'click .edit-calendar': 'editCalendar',
		'click .delete-period': 'deletePeriod',
		'click .delete-calendar': 'deleteCalendar',
		'click .open-history': 'historyInfo'
	},

	render: function(calendar) {
		this.calendar = calendar
		var context = _.cloneDeep(calendar)
		// make sure if there are no periods, we can still call period.length
		// in the template so we know there are 0 periods
		context.periods = context.periods || []
		context.custom = calendar.type === 'custom'
		if (context.custom) {
			_.each(context.periods, period => {
				period.deletable = true
			})
		} else {
			// #24660 allow deleting standard calendar periods,
			// but only the periods at the beginning and end of the calendar
			// and not if replication is enabled
			if (!config.replicationEnabled) {
				if (context.periods.length > 1) {
					_.first(context.periods).deletable = true
					_.last(context.periods).deletable = true
				}
			}
		}

		this.$el.empty().append(template(context))
		// since this view is re-rendered each time a new calendar is selected,
		// only create the tooltips if they don't already exist
		if (!this.covertButtonTooltips) {
			this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })
		}

		// #18523 don't allow synced calendars to be changed
		if (!_.isNil(calendar.syncId) && !permissions.serverAdmin()) {
			this.$('.list-item-details, .add-period, .edit-period, .delete-period, ' +
				'.edit-calendar, .delete-calendar, .extend').remove()
		}

		return this
	},

	extend: function() {
		var form = new ExtendForm({ calendar: this.calendar })
		appDisplay.dialog(form)
		form.on('done', this._done.bind(this))
	},

	addPeriod: function() {
		var form = new PeriodForm({ calendar: this.calendar })
		appDisplay.dialog(form)
		form.on('done', this._done.bind(this))
	},

	editPeriod: function(e) {
		var data = { calendar: this.calendar, period: this._period(e) }
		var form = new PeriodForm(data)
		appDisplay.dialog(form)
		form.on('done', this._done.bind(this))
	},

	editCalendar: function(e) {
		var calendarForm = new CalendarForm({ calendar: this.calendar })
		appDisplay.dialog(calendarForm)
		calendarForm.on('done', function(calendar) {
			this.render(calendar)
			this.trigger('change:calendar', calendar)
		}.bind(this))
	},

	deletePeriod: function(e) {
		let period = this._period(e)
		let url = `api/admin/calendars/${this.calendar.id}/periods/${period.id}/delete-dependencies`
		appDisplay.dialog($.get(url), items => {
			if (_.isEmpty(items)) { // normal delete, no items affected
				// #44189 add warning that deleting a period will trigger score recalc
				// #50666 also include warning about values and notes
				let bannerMessages = [
					i18n.get('admin.recalcScoresConfirm'),
					i18n.get('admin.calendar.deletePeriod.warning')]
				let opts = _.extend(
					{ bannerMessages },
					period)
				let confirmation = new DeleteConfirmation(opts)
				confirmation.once('confirm', () => {
					this.onConfirmDeletePeriod(period, confirmation)
				})
				return confirmation
			} else { // strong confirm, items will be affected
				let key = 'admin.calendar.deletePeriod.warning'
				let confirmation = new StrongConfirmPrompt({
					label: period.label,
					message: this.buildStrongConfirmDeleteMessage(items, key, true)
				})
				confirmation.once('confirm', () => {
					this.onConfirmDeletePeriod(period, confirmation)
				})
				return confirmation
			}
		})
	},

	onConfirmDeletePeriod: function (period, confirmation) {
		var url = 'api/admin/calendars/' + this.calendar.id + '/periods/' + period.id
		$.ajax({
			url,
			type: 'DELETE',
			success: data => {
				this._done(data)
				confirmation.trigger('done')
			},
			error: xhr => {
				appDisplay.replaceDialog(new ErrorView(xhr.responseJSON))
			}
		})
	},

	buildStrongConfirmDeleteMessage: function (items, key, showRecalcMessage) {
		let message = ''
		// #44189 add warning that deleting a period will trigger score recalc
		if (showRecalcMessage) {
			message += `<div class="paragraph">${i18n.get('admin.recalcScoresConfirm')}</div>`
		}
		message += i18n.get(key)
		var buildList = (items, heading) => {
			let html = '<br>'
			html += heading
			html += `<ul>${_.reduce(items, buildListItem, '')}</ul>`
			return html
		}
		var buildListItem = (html, item) => {
			return html + `<li data-id=${item.id}" href="${item.href}" class="sp-navigate">` +
				_.escape(item.label) + '</li>'
		}
		if (!_.isEmpty(items)) {
			message += '<br>'
			let reports = _.filter(items, item => item.domainType === 'report')
			if (!_.isEmpty(reports)) {
				let heading = i18n.get('admin.calendar.deletePeriod.deleted',
					_.lowerCase(i18n.get('report.reports')))
				_.each(reports, item => {
					item.href = `reports/${item.id}`
				})
				message += buildList(reports, heading)
			}
			let exports =  _.filter(items, item => item.domainType === 'scheduled-export')
			if (!_.isEmpty(exports)) {
				let heading = i18n.get('admin.calendar.deletePeriod.deleted',
					_.lowerCase(i18n.get('common.export.scheduledExports')))
				_.each(exports, item => {
					item.href = 'admin/scheduled-exports'
				})
				message += buildList(exports, heading)
			}
			let sharedDashboards = _.filter(items, item => item.domainType === 'embeddable-resource')
			if (!_.isEmpty(sharedDashboards)) {
				let heading = i18n.get('admin.calendar.deletePeriod.deleted',
					_.lowerCase(i18n.get('admin.sharedDashboards')))
				_.each(sharedDashboards, item => {
					item.href = 'admin/shared-dashboards'
				})
				message += buildList(sharedDashboards, heading)
			}
			let slides = _.filter(items, item => item.domainType === 'slide')
			if (!_.isEmpty(slides)) {
				let heading = i18n.get('admin.calendar.deletePeriod.adjusted',
					i18n.get('admin.calendar.deletePeriod.slides'))
				_.each(slides, item => {
					item.href = `briefings/${item.parentId}/slides/${item.id}`
				})
				message += buildList(slides, heading)
			}
			// #50666 warning for any dataset fields that will have their
			// default calendar period id adjusted
			let fields = _.filter(items, item => item.domainType === 'dataset-field')
			if (!_.isEmpty(fields)) {
				let heading =  i18n.get('admin.calendar.deletePeriod.adjusted',
					'datasets.dataset.fields')
				_.each(fields, item => {
					item.href = `datasets/${item.parentId}`
				})
				message += buildList(fields, heading)
			}
			// #50666 warning for any dataset views that will have dataset tables
			// adjusted
			let views = _.filter(items, item => {
				return item.domainType === 'dataset' && item.type === 'view'
			})
			if (!_.isEmpty(views)) {
				let heading =  i18n.get('admin.calendar.deletePeriod.adjusted',
					'datasets.views')
				_.each(views, item => {
					item.href = `datasets/${item.id}`
				})
				message += buildList(views, heading)
			}
		}
		console.log(message)
		return message

	},

	deleteCalendar: function(e) {
		let url = `api/admin/calendars/${this.calendar.id}/delete-dependencies`
		appDisplay.dialog($.get(url), items => {
			if (_.isEmpty(items)) { // normal delete, no items affected
				// #50666 also include warning about values and notes
				let extraBannerMessage = i18n.get('admin.calendar.deletePeriod.warning')
				let opts = _.extend({ extraBannerMessage }, this.calendar)
				let confirmation = new DeleteConfirmation(opts)
				confirmation.once('confirm', () => {
					this.onConfirmDeleteCalendar(confirmation)
				})
				return confirmation
			} else { // strong confirm, items will be affected
				let key = 'admin.calendar.deleteCalendar.warning'
				let confirmation = new StrongConfirmPrompt({
					label: this.calendar.label,
					message: this.buildStrongConfirmDeleteMessage(items, key, false)
				})
				confirmation.once('confirm', () => {
					this.onConfirmDeleteCalendar(confirmation)
				})
				return confirmation
			}
		})
	},

	onConfirmDeleteCalendar(confirmation) {
		$.ajax({
			url: 'api/admin/calendars/' + this.calendar.id,
			type: 'DELETE',
			success: () => {
				// delete is done asyncronously on the server so we have to
				// delete the calendar ourselves here
				var newCalendars = _.remove(calendars.calendars, function(cal) {
					return cal.id != this.calendar.id
				}.bind(this))
				calendars.reset({
					calendars: newCalendars,
					defaultPeriods: calendars.defaultPeriods
				})
				confirmation.trigger('done')
				conductor.navigate('admin/calendars', { trigger: true })
			},
			error: createjQueryErrorHandler({ model: this.calendar })
		})
	},

	historyInfo: function() {
		var model = _.extend(_.cloneDeep(this.calendar), { section: 'calendars'})
		CalendarHistoryInfo.display(model, model.label)
	},

	// returns the calendar period corresponding to the given dom event
	_period: function(e) {
		var id = $(e.target).closest('[data-id]').data('id')
		return calendars.periodsById[id]
	},

	// handle a form finishing its work by re-rendering the period list
	_done: function(data) {
		if (data) {
			calendars.reset(data)
		}
		var calendar = calendars.calendarsById[this.calendar.id]
		this.render(calendar)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips], 'remove')
	}

})

export default PeriodList

PeriodList.__filename__ = 'admin/calendars/period-list.js'
